import type { Component } from 'solid-js'
import { useTransContext } from '@mbarzda/solid-i18next'
import type { SectionMetrics } from '../../../features/engagement/domain/models/sections'
import { ChartContainerWithHeader, ChartLegend, useChartWithLegend, useLegendState } from '../../shared/charts'
import {
  getSectionsStackedChartOptions,
  getSectionsStackedLegendItems,
  SECTIONS_STACKED_INITIAL_LEGEND_STATE,
  type SectionsMetricKey
} from './SectionsStackedChart.vm'

interface SectionsStackedChartProps {
  sections: SectionMetrics[]
  metric: SectionsMetricKey
}

const SectionsStackedChart: Component<SectionsStackedChartProps> = (props) => {
  let chartRef: HTMLDivElement | undefined

  const [t] = useTransContext()

  const { state: legendState, toggle } = useLegendState(SECTIONS_STACKED_INITIAL_LEGEND_STATE)

  useChartWithLegend({
    data: () => ({ sections: props.sections, metric: props.metric }),
    chartRef: () => chartRef,
    legendState,
    buildOptions: (data, legend) => getSectionsStackedChartOptions(data.sections, data.metric, legend, t)
  })

  const hasData = () => props.sections.some((s) => s.section !== 'other' && s.periods.length > 0)

  return (
    <ChartContainerWithHeader
      hasData={hasData()}
      title={`${t('ls_sections_stacked_title')} ${t('ls_sections_excl_other')}`}
    >
      <ChartLegend items={getSectionsStackedLegendItems(t)} activeKeys={legendState()} onToggle={toggle} class="mb-4" />
      <div ref={chartRef} />
    </ChartContainerWithHeader>
  )
}

export default SectionsStackedChart
